import { render } from "./PasswordChangeView.vue?vue&type=template&id=6e05248c"
import script from "./PasswordChangeView.vue?vue&type=script&lang=js"
export * from "./PasswordChangeView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__